"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dashboard = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _utils = require("./utils");

var _QueryParameters = _interopRequireDefault(require("./QueryParameters"));

var _AnalyticsDateFormatter = _interopRequireDefault(require("./AnalyticsDateFormatter"));

var _DashboardDateRangeFilter = _interopRequireDefault(require("./DashboardDateRangeFilter"));

var _service = require("@insided/deprecated-control/analytics/service");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Dashboard = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Dashboard, _Component);

  var _super = _createSuper(Dashboard);

  function Dashboard(props, context) {
    var _this;

    (0, _classCallCheck2.default)(this, Dashboard);
    _this = _super.call(this, props, context);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "wrapperRef", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "barChart", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "resizeTimeout", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClickOutside", function (e) {
      if (!_this.wrapperRef) return;

      if (!_this.wrapperRef.contains(e.target)) {
        _this.onResetDateRange();

        _this.setState({}, _this.removeHandler);
      }
    });

    var _getStartAndEndDate = (0, _utils.getStartAndEndDate)(),
        initialStartDate = _getStartAndEndDate.initialStartDate,
        initialEndDate = _getStartAndEndDate.initialEndDate,
        initalDateRangeId = _getStartAndEndDate.initalDateRangeId;

    var queryParams = new _QueryParameters.default();

    _this.setState({
      selectedPresetDateRangeId: queryParams.has('date_range') ? queryParams.get('date_range') : initalDateRangeId,
      storedState: {
        presetDateRangeId: queryParams.has('date_range') ? queryParams.get('date_range') : initalDateRangeId,
        selectedDateRange: (0, _utils.getDefaultSelectedDate)()
      },
      startDate: queryParams.has('date_from') ? (0, _utils.getDateWithDefaultTime)(queryParams.get('date_from')) : initialStartDate,
      endDate: queryParams.has('date_till') ? (0, _utils.getDateWithDefaultTime)(queryParams.get('date_till')) : initialEndDate,
      presetDateRangeList: [],
      isDateRangeOpen: false,
      isLoading: false,
      shouldChartRedraw: false
    });

    return _this;
  }

  (0, _createClass2.default)(Dashboard, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var presetDateRanges, defaultDateRange, _dateRangeForDisplay, dateFrom, dateTill, selectedDateRange, selectedPresetId, updatedState;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.redrawGraphsOnResize();
                this.setState({
                  isLoading: true
                });
                _context.prev = 2;
                _context.next = 5;
                return (0, _service.fetchDateRangeFilter)();

              case 5:
                presetDateRanges = _context.sent;
                defaultDateRange = (0, _utils.getDefaultDateRange)(presetDateRanges, this.state.selectedPresetDateRangeId);
                _dateRangeForDisplay = (0, _utils.dateRangeForDisplay)(this.state.storedState, defaultDateRange, this.state.selectedPresetDateRangeId), dateFrom = _dateRangeForDisplay.dateFrom, dateTill = _dateRangeForDisplay.dateTill, selectedDateRange = _dateRangeForDisplay.selectedDateRange, selectedPresetId = _dateRangeForDisplay.selectedPresetId, updatedState = _dateRangeForDisplay.updatedState;
                this.setState({
                  presetDateRangeList: presetDateRanges,
                  selectedPresetDateRangeId: selectedPresetId,
                  selectedDate: selectedDateRange,
                  startDate: dateFrom,
                  endDate: dateTill,
                  storedState: updatedState,
                  isLoading: false
                });
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](2);
                this.setState({
                  isLoading: false
                });

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 11]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }() // @ts-expect-error

  }, {
    key: "addHandler",
    value: function addHandler() {
      var isDateRangeOpen = this.state.isDateRangeOpen;

      if (isDateRangeOpen) {
        window.document.addEventListener('mousedown', this.handleClickOutside);
      }
    }
  }, {
    key: "removeHandler",
    value: function removeHandler() {
      window.document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "redrawGraphsOnResize",
    value: function redrawGraphsOnResize() {
      var _this2 = this;

      if (typeof window.ResizeObserver === 'undefined') {
        return;
      }

      var resizeObserver = new ResizeObserver(function () {
        clearTimeout(_this2.resizeTimeout);

        _this2.setState({
          shouldChartRedraw: true
        });

        _this2.resizeTimeout = window.setTimeout(function () {
          return _this2.setState({
            shouldChartRedraw: false
          });
        }, 2 * 10);
      });

      if (this.barChart != null) {
        resizeObserver.observe(this.barChart);
      }
    }
  }, {
    key: "toggleDateRange",
    value: function toggleDateRange(value) {
      this.setState({
        isDateRangeOpen: value
      }, this.addHandler);
    }
  }, {
    key: "onPresetDateRangeChanged",
    value: function onPresetDateRangeChanged(selectedDate) {
      this.setState({
        selectedPresetDateRangeId: selectedDate.id,
        selectedDate: selectedDate
      });
    }
  }, {
    key: "onCustomDateRangeChanged",
    value: function onCustomDateRangeChanged(dates) {
      var customSelectedDate = {
        id: 'custom_range',
        label: 'Custom Range',
        startDate: dates[0],
        endDate: dates[1]
      };
      this.setState({
        selectedDate: customSelectedDate,
        selectedPresetDateRangeId: customSelectedDate.id
      });
    }
  }, {
    key: "onDateRangeChanged",
    value: function onDateRangeChanged() {
      var _this$state = this.state,
          selectedDate = _this$state.selectedDate,
          selectedPresetDateRangeId = _this$state.selectedPresetDateRangeId;
      this.setState(function (prevState) {
        return {
          isDateRangeOpen: false,
          startDate: new Date(selectedDate.startDate),
          endDate: new Date(selectedDate.endDate),
          storedState: _objectSpread(_objectSpread({}, prevState.storedState), {}, {
            presetDateRangeId: selectedPresetDateRangeId,
            selectedDateRange: selectedDate
          })
        };
      });
      var queryString = new _QueryParameters.default();
      queryString.set('date_range', selectedPresetDateRangeId);

      if (selectedPresetDateRangeId !== 'custom_range') {
        queryString.unset('date_from').unset('date_till');
      } else {
        queryString.set('date_from', _AnalyticsDateFormatter.default.formatDateForUrl(selectedDate.startDate)).set('date_till', _AnalyticsDateFormatter.default.formatDateForUrl(selectedDate.endDate));
      }

      window.history.pushState(null, 'date range changed', queryString.getQueryString());
      (0, _utils.updateDateRangeInSessionStorage)(selectedDate);
      this.refetchData();
    }
  }, {
    key: "onResetDateRange",
    value: function onResetDateRange() {
      var _this$state$storedSta = this.state.storedState,
          presetDateRangeId = _this$state$storedSta.presetDateRangeId,
          selectedDateRange = _this$state$storedSta.selectedDateRange;
      this.setState({
        isDateRangeOpen: false,
        selectedPresetDateRangeId: presetDateRangeId,
        selectedDate: selectedDateRange
      });
    }
  }, {
    key: "getDateRangeFilter",
    value: function getDateRangeFilter() {
      var _this3 = this;

      var _this$state2 = this.state,
          isLoading = _this$state2.isLoading,
          startDate = _this$state2.startDate,
          endDate = _this$state2.endDate,
          isDateRangeOpen = _this$state2.isDateRangeOpen,
          presetDateRangeList = _this$state2.presetDateRangeList,
          selectedDate = _this$state2.selectedDate,
          selectedPresetDateRangeId = _this$state2.selectedPresetDateRangeId;
      return (0, _preact.h)(_DashboardDateRangeFilter.default, {
        isLoading: isLoading,
        startDate: startDate,
        endDate: endDate,
        isDropdownOpen: isDateRangeOpen,
        items: presetDateRangeList,
        selectedDate: selectedDate,
        selectedPresetId: selectedPresetDateRangeId,
        toggleDropdown: function toggleDropdown(v) {
          return _this3.toggleDateRange(v);
        },
        onChange: function onChange() {
          return _this3.onDateRangeChanged();
        },
        onReset: function onReset() {
          return _this3.onResetDateRange();
        },
        onCustomDateChange: function onCustomDateChange(dates) {
          return _this3.onCustomDateRangeChanged(dates);
        },
        onPresetDateChange: function onPresetDateChange(selectedDate) {
          return _this3.onPresetDateRangeChanged(selectedDate);
        },
        showMonths: 2,
        "data-element-name": "Date range filter",
        "data-track-type": "click"
      });
    }
  }]);
  return Dashboard;
}(_preact.Component);

exports.Dashboard = Dashboard;